<template>
  <div>
    <vue-editor
      useCustomImageHandler
      @image-added="handleImageAdded"
      @image-removed="handleImageRemove"
      v-model="content"
      @text-change="TextChange"
    ></vue-editor>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
export default {
  name: "BlogTextEditerComponent",
  components: {
    VueEditor,
  },
  props: ["Content"],
  watch: {
    Content() {
      this.content = this.Content;
    },
  },
  data() {
    return {
      content: "<h1>Lorem ipsum</h1>",
      isEditing: false,
    };
  },
 

  methods: {
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
       
      this.$store.dispatch("UploadImage", file).then((res) => { 
        Editor.insertEmbed(cursorLocation, "image", res);
        resetUploader();
      });
    },
    handleImageRemove(file) {
      this.$store.dispatch("DeleteImage", file);
    },
    TextChange() {
      this.isEditing = true;
      this.$emit("SetContent", this.content);
    },
    SaveDraft() {},
  },
};
</script>
